/**
 * Created by Vit on 10.10.2017.
 */
/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';

import 'styles/base/components/layout-container/_layout.scss';

const classes = new Bem('layout');

/**
 *
 * = Layout component =
 *
 * === Example ===
 * <LayoutContainer>
 *   <Stretch>
 *     Stretch content
 *   </Stretch>
 *   <Fixed height="20rem">
 *     Fixed content
 *   </Fixed>
 * </LayoutContainer>
 *
 */

class LayoutContainer extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    absolute: PropTypes.bool,
    row: PropTypes.bool,
    allVisible: PropTypes.bool,
  };

  render() {
    const {
      className, children, row,
      absolute, allVisible
    } = this.props;
    const mods = {
      row, absolute, allVisible
    };

    return (
      <div
        {...classes(null, mods, className)}
        children={children}
      />
    );
  }
}

const classesStretch = new Bem('stretch');

class Stretch extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
  };

  render() {
    const { className, children } = this.props;

    return (
      <div
        {...classesStretch({ extra: className })}
        children={children}
      />
    );
  }
}

const classesFixed = new Bem('fixed');

class Fixed extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
    overflowHidden: PropTypes.bool
  };

  static defaultProps = {
    height: '',
    width: ''
  };

  render() {
    const {
      className, children,
      height, width, overflowHidden
    } = this.props;
    const mods = {
      overflowHidden
    };

    return (
      <div
        {...classesFixed(null, mods, className)}
        style={{ height, width, maxWidth: width, minWidth: width }}
        children={children}
      />
    );
  }
}

export {
  LayoutContainer as default,
  Stretch,
  Fixed
};
